import srraf from "srraf"
import EVENTS from "../lib/events.js"

const {
  CART_DRAWER_OPEN,
  PREDICTIVE_SEARCH_DRAWER_OPEN,
  HEADER_HEIGHT_UPDATED,
  SHOPIFY_BLOCK_SELECT,
  SHOPIFY_BLOCK_DESELECT,
} = EVENTS

class HeaderWrapper extends HTMLElement {
  static observedAttributes = ["data-is-sticky"]

  constructor() {
    super()

    this.selectors = {
      showCartDrawerButton: "[data-action='show-cart-drawer']",
      showPredictiveSearchDrawerButton:
        "[data-action='show-predictive-search-drawer']",
    }
  }

  connectedCallback() {
    this.eventController = new AbortController()

    const eventOptions = { signal: this.eventController.signal }

    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_SELECT,
      (e) => this.handleBlockSelected(e.detail.blockId),
      eventOptions,
    )

    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_DESELECT,
      () => this.handleBlockDeselected(),
      eventOptions,
    )

    this.setHeightVariable()
    this.widthWatcher = srraf(({ vw, pvw }) => {
      if (vw === pvw) return
      this.setHeightVariable()
    })

    // Cart Drawer button
    this.querySelectorAll(this.selectors.showCartDrawerButton).forEach(
      (element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault()
          window.dispatchEvent(new Event(CART_DRAWER_OPEN))
        })
      },
    )

    // Search button
    this.querySelectorAll(
      this.selectors.showPredictiveSearchDrawerButton,
    ).forEach((element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault()
        window.dispatchEvent(new Event(PREDICTIVE_SEARCH_DRAWER_OPEN))
      })
    })
  }

  disconnectedCallback() {
    this.eventController.abort()
    this.widthWatcher?.destroy()
  }

  attributeChangedCallback(name, _oldValue, _newValue) {
    if (name === "data-is-sticky") {
      this.setHeightVariable()
    }
  }

  handleBlockSelected() {}

  handleBlockDeselected() {}

  /**
   * Measures the header's height and applies that value to a document CSS variable.
   * The header uses the `-internal` custom property to position itself out of the viewport
   * until it has become stuck.
   *
   * the public `--header-height` is available to see the headers height when stuck.
   */
  setHeightVariable() {

    if (this.offsetHeight !== this.lastSetHeight) {
      document.documentElement.style.setProperty(
        "--header-height-internal",
        `${this.offsetHeight}px`,
      )
      document.dispatchEvent(
        new CustomEvent(HEADER_HEIGHT_UPDATED, {
          detail: { height: this.offsetHeight },
        }),
      )
      this.lastSetHeight = this.offsetHeight
    }

    // Header is sticky, but currently not stuck, so header height is temporarily 0px
    if (this.dataset.isSticky === "false") {
      document.documentElement.style.setProperty("--header-height", "0px")
      return
    }

    // Header is stuck, make the internal height the public height
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.offsetHeight}px`,
    )
  }
}

if (!customElements.get("header-wrapper")) {
  customElements.define("header-wrapper", HeaderWrapper)
}
